import cleanAuthData from './cleanAuthData';
export default (accountsUrl) => {
    cleanAuthData();
    window.location.replace(`${accountsUrl}/logout?redirect=${window.location.origin}`);
};
//# sourceMappingURL=logoutRedirect.js.map